import { render } from "./ResidentialView.vue?vue&type=template&id=4ea16820&ts=true"
import script from "./ResidentialView.vue?vue&type=script&lang=ts"
export * from "./ResidentialView.vue?vue&type=script&lang=ts"

import "./ResidentialView.vue?vue&type=style&index=0&id=4ea16820&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__